<template>
<q-page padding>
  <!-- content -->
  <h1>Sample</h1>
</q-page>
</template>

<script>
export default {
  // name: 'PageName',
  data () {
    return {
      title: 'Sample'
    }
  }
}
</script>
